<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>媒体专访</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="publish_main">
            <p>科研成果在艺术家看来都是垃圾？</p>

            <p class="con_p">
                 马兆远，清华大学未来实验室首席研究员，数字化先进制造研究中心主任，英国谢菲尔德大学智能制造专业教授。
            </p>

            <p class="con_p">
                 作为一名物理学家，他对艺术的兴趣开始于初中时代偷看哥哥的画册。但他对艺术比较系统全面的启蒙确是在大学时和朱青生学习艺术理论之后。
                 后来去牛津读书的时候做话剧导演，有了“马导”的称号，也结识了很多艺术圈朋友。现在，他加入清华大学成立未来实验室，
                 其创办人是清华美院的徐迎庆教授，再一次和艺术建立了联。未来实验室一个重要的研究方向就是从量子力学的角度探讨人工智能的发展，
                 科学艺术相互融合，便有了新的实验室——AI-NOT。
            </p>
            <!-- <div class="eq-box">
                <p class="con_p" style="text-indent: 0; margin-bottom: 10px;">此次演讲中，“马导”重点展开以下几个观点：</p>
                <p class="eq_fruit">1.艺术与科学不分彼此</p>
                <p class="eq_fruit">2.科研成果在艺术看来都是垃圾？</p>
                <p class="eq_fruit">3.什么是理性？</p>
                <p class="eq_fruit">4.几何~艺术：另一个形式化样板  </p>
                <p class="eq_fruit" style="margin-bottom: 34px;">5.理性的终极追求</p>
            </div> -->

            <div class="video-com">
                <iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=g0840ydqr7t" allowFullScreen="true" height="450" width="700"></iframe>
               
                
                <!-- <iframe class="video_iframe" style="z-index:1;" src="https://v.qq.com/x/page/g0840ydqr7t.html?vid=pc841.com&amp;width=500&amp;height=375&amp;auto=0"  
                 allowfullscreen="" frameborder="0" height="450" width="700">
                </iframe> -->
            </div>

        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
     /* height: 681px; */
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }
 .banner_warp {
     position: absolute;
     top: 0px;
     left: 19%;
 }
 .top-text {
     width: 570px;
     position: absolute;
     top: 300px;

 }
 .top-text p:nth-child(1) {
     font-size: 40px;
     color: #ffffff;
 }
 .top-text p:nth-child(2) {
     font-size: 19px;
     color: #ffffff;
     margin-top: 10px;
 }

/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.publish_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    overflow: hidden;
    padding-bottom: 80px;
}
.publish_main p:nth-child(1) {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
    margin-bottom: 73px;
}
.publish_main .con_p {
    font-size: 14px;
    text-indent: 2em;
    margin-bottom: 34px;
}

.publish_main .eq_fruit {
    font-size: 18px;
    margin-left: 40px;
    font-weight: 700;
}

.publish_main img{
    display: block;
    margin: 0 auto;
    /* margin-bottom: 100px; */
    margin-top: 100px;
}


.video-com {
    width: 701px;
    height: 452px;
    margin: 0 auto;
    margin-top: 50px;
}

/* 问题的文字 */
 .publish_main .eq-box {
     width: 500px;
    margin: 0 auto;
 }

  .publish_main .eq-box .con_p {
      font-size: 22px;
      /* font-weight: normal; */
  }
</style>



// WEBPACK FOOTER //
// src/components/news/fruit/fruit.vue